import { contractReviewerConstants as constants, categoryConstants, uploadState as UploadState } from '../constants';
import { helper } from '../helpers/helper';

const initialState = {
    uploadFile: null, uploadId: "", uploadState: UploadState.START,
    finishedFiles: [],
    id: "", documentHtml: "", fileName: "", uploadError: "",
    uploadDate: 0, availableToDate: 0,
    documents: [],
    templateDocuments: [],
    analyzedDocuments: {},
    exceptions: [],
    isLoading: [],
    shouldRefreshAnalysis: false,
    refreshAnalysisDelay: 0
};

export const contractReviewer = (state, action) => {
    state = state || initialState;

    if (action.type === constants.DESELECT_DOCUMENT) {
        return {
            ...state,
            id: ""
        }
    }

    // LIST DOCUMENTS
    if (action.type === constants.GET_DOCUMENTS_LIST_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_DOCUMENTS_LIST_REQUEST]
        };
    }

    if (action.type === constants.GET_DOCUMENTS_LIST_SUCCESS) {
        return {
            ...state,
            documents: action.documents,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_DOCUMENTS_LIST_REQUEST)
        };
    }

    if (action.type === constants.GET_DOCUMENTS_LIST_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_DOCUMENTS_LIST_REQUEST)
        };
    }

    if (action.type === constants.GET_TEMPLATE_DOCUMENTS_LIST_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_TEMPLATE_DOCUMENTS_LIST_REQUEST]
        };
    }
    if (action.type === constants.GET_TEMPLATE_DOCUMENTS_LIST_SUCCESS) {
        return {
            ...state,
            documents: action.documents,
            templateDocuments: action.templateDocuments,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_TEMPLATE_DOCUMENTS_LIST_REQUEST)
        };
    }
    if (action.type === constants.GET_TEMPLATE_DOCUMENTS_LIST_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_TEMPLATE_DOCUMENTS_LIST_REQUEST)
        };
    }

    // GET DOCUMENT ANALYSIS
    if (action.type === constants.GET_DOCUMENT_ANALYSIS_REQUEST) {

        let doc = state.analyzedDocuments[action.id];
        let isAlreadyWaiting = state.isLoading.includes(constants.GET_DOCUMENT_ANALYSIS_REQUEST);
        return {
            ...state,
            id: action.id,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...doc,
                    id: action.id,
                    fileName: doc ? doc.fileName : "",
                    documentHtml: doc ? doc.html : "",
                    pageCount: doc ? doc.pageCount : 0,
                    contractType: doc ? doc.agreementType : "",
                    uploadedDate: doc ? doc.uploadedDate : "",
                    availableToDate: doc ? doc.availableToDate : "",
                    themePackageId: doc ? doc.themePackageId : "",
                    themePackageName: doc ? doc.themePackageName : "",
                    canExportToWord: doc ? doc.canExportToWord : false,
                    highlights: doc ? doc.highlights : [],
                    missingHighlights: doc ? doc.missingHighlights : [],
                    images: doc ? doc.images : [],
                    segments: doc ? doc.segments : [],
                    wasSuccessful: false,
                    summary: doc ? doc.summary : {}
                }
            },
            isLoading: isAlreadyWaiting ? state.isLoading.slice() : [...state.isLoading, constants.GET_DOCUMENT_ANALYSIS_REQUEST],
            shouldRefreshAnalysis: false
        };
    }

    if (action.type === constants.GET_DOCUMENT_ANALYSIS_SUCCESS) {
        let doc = state.analyzedDocuments[action.id];
        let highlights = action.highlights ? action.highlights : [];
        var updatedHighlights = doc && doc.summary && doc.summary.highlights ? helper.mergeHighlightsWithFeedback(highlights, doc.summary.highlights) : highlights;
        return {
            ...state,
            id: action.id,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    id: action.id,
                    fileName: action.fileName,
                    documentHtml: action.html,
                    pageCount: action.pageCount,
                    contractType: action.agreementType,
                    uploadedDate: action.uploadedDate,
                    availableToDate: action.availableToDate,
                    themePackageId: action.themePackageId,
                    themePackageName: action.themePackageName,
                    canExportToWord: action.canExportToWord,
                    highlights: updatedHighlights,
                    missingHighlights: action.missingHighlights ? action.missingHighlights : [],
                    images: action.images ? action.images : [],
                    segments: [],
                    wasSuccessful: action.wasSuccessful,
                    refreshAnalysisDelay: 0,
                    shouldRefreshAnalysis: false,
                    summary: doc ? doc.summary : {}
                }
            },
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_DOCUMENT_ANALYSIS_REQUEST)
        };
    }

    if (action.type === constants.GET_DOCUMENT_ANALYSIS_PENDING) {
        return {
            ...state,
            shouldRefreshAnalysis: true,
            refreshAnalysisDelay: 3
        };
    }

    if (action.type === constants.GET_DOCUMENT_ANALYSIS_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_DOCUMENT_ANALYSIS_REQUEST),
            shouldRefreshAnalysis: false,
            refreshAnalysisDelay: 0
        };
    }

    // GET COMPARISON DOCUMENT ANALYSIS
    if (action.type === constants.GET_COMPARISON_DOCUMENT_ANALYSIS_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_COMPARISON_DOCUMENT_ANALYSIS_REQUEST]
        };
    }

    if (action.type === constants.GET_COMPARISON_DOCUMENT_ANALYSIS_SUCCESS) {
        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    id: action.id,
                    fileName: action.fileName,
                    documentHtml: action.html,
                    pageCount: action.pageCount,
                    contractType: action.agreementType,
                    uploadedDate: action.uploadedDate,
                    availableToDate: action.availableToDate,
                    themePackageId: action.themePackageId,
                    themePackageName: action.themePackageName,
                    canExportToWord: action.canExportToWord,
                    highlights: action.highlights ? action.highlights : [],
                    missingHighlights: action.missingHighlights ? action.missingHighlights : [],
                    images: action.images ? action.images : {},
                    segments: [],
                    wasSuccessful: action.wasSuccessful
                }
            },
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_COMPARISON_DOCUMENT_ANALYSIS_REQUEST)
        };
    }

    if (action.type === constants.GET_COMPARISON_DOCUMENT_ANALYSIS_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_COMPARISON_DOCUMENT_ANALYSIS_REQUEST)
        };
    }

    // GET DOCUMENT SEGMENTS
    if (action.type === constants.GET_DOCUMENT_SEGMENTS_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_DOCUMENT_SEGMENTS_REQUEST]
        };
    }

    if (action.type === constants.GET_DOCUMENT_SEGMENTS_SUCCESS) {
        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...state.analyzedDocuments[action.id],
                    segments: action.segments ? action.segments : []
                }
            },
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_DOCUMENT_SEGMENTS_REQUEST)
        };
    }

    if (action.type === constants.GET_DOCUMENT_SEGMENTS_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_DOCUMENT_SEGMENTS_REQUEST)
        };
    }

    // UPLOAD
    if (action.type === constants.START_UPLOAD_SINGLE) {
        return {
            ...initialState,
            isLoading: [...state.isLoading, constants.START_UPLOAD_SINGLE],
            uploadState: UploadState.UPLOADING_SINGLE
        };
    }

    if (action.type === constants.FINISH_UPLOAD_SINGLE) {
        return {
            ...state,
            uploadId: action.id,
            fileName: action.fileName,
            uploadFile: action.file,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.START_UPLOAD_SINGLE),
            uploadState: UploadState.PROCESSING
        };
    }

    if (action.type === constants.START_UPLOAD_MULTIPLE) {
        return {
            ...initialState,
            isLoading: [...state.isLoading, constants.START_UPLOAD_MULTIPLE],
            uploadState: UploadState.UPLOADING_MULTIPLE
        };
    }

    if (action.type === constants.UPDATE_UPLOAD_MULTIPLE) {
        return {
            ...state,
            finishedFiles: [...state.finishedFiles, action.fileName],  //ToDo: skicka filename från action och spara filenames i state
            uploadError: action.uploadError ? action.uploadError + " - " + action.fileName : action.uploadError,
            uploadState: UploadState.UPLOADING_MULTIPLE
        };
    }

    if (action.type === constants.FINISH_UPLOAD_MULTIPLE) {
        return {
            ...state,
            uploadId: action.id,
            fileName: action.fileName,
            uploadFile: action.file,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.START_UPLOAD_MULTIPLE),
            uploadState: UploadState.END_OF_MULTIUPLOAD
        };
    }

    if (action.type === constants.RESET_UPLOAD_STATE) {
        return {
            ...state,
            uploadId: "",
            finishedFiles: [],
            files: [],
            uploadState: UploadState.START
        };
    }

    if (action.type === constants.FAILED_UPLOAD) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.START_UPLOAD_SINGLE)
        };
    }

    // PROCESS DOCUMENT
    if (action.type === constants.PROCESS_DOCUMENT_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.PROCESS_DOCUMENT_REQUEST],
            uploadState: UploadState.PROCESSING
        };
    }

    if (action.type === constants.PROCESS_DOCUMENT_SUCCESS) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.PROCESS_DOCUMENT_REQUEST],
            uploadState: UploadState.WAITING_TO_SELECT_TYPE
        };
    }

    if (action.type === constants.PROCESS_DOCUMENT_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.PROCESS_DOCUMENT_REQUEST)
        };
    }

    // EDIT DOCUMENT TYPE
    if (action.type === constants.EDIT_DOCUMENT_TYPE_REQUEST) {
        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...state.analyzedDocuments[action.id],
                    contractType: action.contractType
                }
            },
            uploadState: action.isUploading ? UploadState.SELECTING_TYPE : state.uploadState
        };
    }

    if (action.type === constants.EDIT_DOCUMENT_TYPE_SUCCESS) {
        return {
            ...state,
            uploadState: action.isUploading ? UploadState.LOADING : state.uploadState,
            shouldRefreshAnalysis: true
        };
    }

    if (action.type === constants.EDIT_DOCUMENT_TYPE_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EDIT_DOCUMENT_TYPE_REQUEST)
        };
    }

    // DELETE DOCUMENT
    if (action.type === constants.DELETE_DOCUMENT_SUCCESS) {
        let docs = state.documents.filter(x => x.id !== action.id);
        let analyzedDocs = { ...state.analyzedDocuments };
        delete analyzedDocs[action.id]

        return {
            ...state,
            id: state.id === action.id ? "" : state.id,
            documents: docs,
            analyzedDocuments: {
                ...analyzedDocs
            }
        };
    }

    if (action.type === constants.DELETE_DOCUMENT_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.DELETE_DOCUMENT_REQUEST)
        };
    }

    // ADD TEXT SEGMENT
    if (action.type === constants.ADD_TEXT_SEGMENT_SUCCESS) {
        let doc = state.analyzedDocuments[action.id];
        let segments = doc ? [...doc.segments] : [];
        segments.push(action.segment)
        segments.sort((a, b) => a.startPosition - b.startPosition);

        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...state.analyzedDocuments[action.id],
                    segments
                }
            }
        };
    }

    if (action.type === constants.ADD_TEXT_SEGMENT_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.ADD_TEXT_SEGMENT_REQUEST)
        };
    }

    // DELETE TEXT SEGMENT
    if (action.type === constants.DELETE_TEXT_SEGMENT_SUCCESS) {
        let doc = state.analyzedDocuments[action.id];
        let segments = doc ? [...doc.segments] : [];
        segments = segments.filter(x => x.id !== action.id);

        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...state.analyzedDocuments[action.id],
                    segments
                }
            }
        };
    }

    if (action.type === constants.DELETE_TEXT_SEGMENT_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.DELETE_TEXT_SEGMENT_REQUEST)
        };
    }

    // EDIT HIGHLIGHT NOTES
    if (action.type === constants.EDIT_HIGHLIGHT_NOTES_SUCCESS) {

        //Update the instance in the predicted segments list.
        let doc = state.analyzedDocuments[action.id];
        let highlights = doc ? doc.highlights.slice() : [];
        let pos = highlights.findIndex(x => x.textSegmentId == action.textSegmentId && x.categoryCode == action.categoryCode);
        if (pos != -1) highlights[pos].notes = action.notes;

        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...state.analyzedDocuments[action.id],
                    highlights
                }
            }
        };
    }

    if (action.type === constants.EDIT_HIGHLIGHT_NOTES_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EDIT_HIGHLIGHT_NOTES_REQUEST)
        };
    }

    // EDIT HIGHLIGHT IS SELECTED
    if (action.type === constants.EDIT_HIGHLIGHT_IS_SELECTED_SUCCESS) {

        //Update the instance in the predicted segments list.
        let doc = state.analyzedDocuments[action.id];
        let highlights = doc ? doc.highlights.slice() : [];
        let pos = highlights.findIndex(x => x.textSegmentId == action.textSegmentId && x.categoryCode == action.categoryCode);
        highlights[pos].isSelected = action.isSelected;

        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...state.analyzedDocuments[action.id],
                    highlights
                }
            }
        };
    }

    if (action.type === constants.EDIT_HIGHLIGHT_IS_SELECTED_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EDIT_HIGHLIGHT_IS_SELECTED_REQUEST)
        };
    }

    // COMPARE DOCUMENTS
    if (action.type === constants.COMPARE_DOCUMENTS_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.COMPARE_DOCUMENTS_REQUEST]
        };
    }

    if (action.type === constants.COMPARE_DOCUMENTS_SUCCESS) {
        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    id: action.id,
                    fileName: action.fileName,
                    documentHtml: action.html,
                    pageCount: action.pageCount,
                    contractType: action.agreementType,
                    uploadedDate: action.uploadedDate,
                    availableToDate: action.availableToDate,
                    themePackageId: action.themePackageId,
                    themePackageName: action.themePackageName,
                    canExportToWord: action.canExportToWord,
                    highlights: action.highlights ? action.highlights : [],
                    missingHighlights: action.missingHighlights ? action.missingHighlights : [],
                    segments: []
                }
            },
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.COMPARE_DOCUMENTS_REQUEST)
        };
    }

    if (action.type === constants.COMPARE_DOCUMENTS_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.COMPARE_DOCUMENTS_REQUEST)
        };
    }

    // EXPORT AS DOCX
    if (action.type === constants.EXPORT_AS_DOCX_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.EXPORT_AS_DOCX_REQUEST]
        };
    }

    if (action.type === constants.EXPORT_AS_DOCX_SUCCESS) {
        return {
            ...state,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EXPORT_AS_DOCX_REQUEST)
        };
    }

    if (action.type === constants.EXPORT_AS_DOCX_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EXPORT_AS_DOCX_REQUEST)
        };
    }

    // CATEGORY: EDIT THEME PACKAGE
    if (action.type === categoryConstants.ADD_OR_UPDATE_CATEGORY_THEME_REQUEST) {
        return {
            ...state
        };
    }

    if (action.type === categoryConstants.ADD_OR_UPDATE_CATEGORY_THEME_SUCCESS) {
        let doc = state.analyzedDocuments[state.id];
        let shouldRefreshAnalysis = doc && doc.themePackageId == action.id;

        return {
            ...state,
            shouldRefreshAnalysis
        };
    }

    if (action.type === categoryConstants.ADD_OR_UPDATE_CATEGORY_THEME_FAILURE) {
        return {
            ...state
        };
    }

    // FEEDBACK & SUMMARY
    if (action.type === constants.GET_DOCUMENT_SUMMARY_REQUEST) {
        return {
            ...state
        };
    }

    if (action.type === constants.GET_DOCUMENT_SUMMARY_SUCCESS) {
        var currentHighlights = state.analyzedDocuments[action.id] && state.analyzedDocuments[action.id].highlights
            ? state.analyzedDocuments[action.id].highlights
            : [];
        var updatedHighlights = helper.mergeHighlightsWithFeedback(currentHighlights, action.summary.highlights);

        return {
            ...state,
            analyzedDocuments: {
                ...state.analyzedDocuments,
                [action.id]: {
                    ...state.analyzedDocuments[action.id],
                    summary: action.summary,
                    highlights: updatedHighlights
                }
            }
        };
    }

    if (action.type === constants.GET_DOCUMENT_SUMMARY_FAILURE) {
        return {
            ...state
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/contractReviewer.reducer.js